export default function SpinnerForButton({ show, noMargin = false}) {
    if (!show) return;
    return (<span className={`spinner-border spinner-border-sm ${noMargin ? '' : 'me-05'}`}></span>);
}